import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {toast} from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';

import {GET_COMMISSION_REPORT} from "../../actions/ActionTypes";
import ErrorMsg from "../common/ErrorMsg";
import {downloadPDF} from "../common/Constants";
import loadingGIF from "../../public/assets/images/loading.gif";
import AgencyRevenueService from "../../services/AgencyRevenueService";


export default class CommissionReport extends Component {
    
    state = {
        selectedCompensationId: 0,
        compensationProfileList: [],
        isLoading: false,
        reviewDate: moment(),
        revenueActualList: []
    };

    componentDidMount() {
        this.getUserCompensation();
    }

    getUserCompensation = async () => {
        try {
            let result = await this.props.getStaffCompensationList();
            if (result) {
                let compensationProfileList = result.map(profile => ({...profile}));
                this.setState({compensationProfileList}, () => {
                    if (this.props.staffDashboard.staffKPIList) {
                        let selectedCompensationId = this.props.staffDashboard.staffKPIList.compensation_profile_id;
                        this.setState({selectedCompensationId});
                        this.getCompensationSetting(selectedCompensationId);
                    }
                });
            }            
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    };

    compensationChangeHandler = (event) => {
        let selectedCompensationId = parseInt(event.currentTarget.value);
        if (selectedCompensationId > 0) {
            this.setState({selectedCompensationId});
            this.getCompensationSetting(selectedCompensationId);
        }
    };

    getCompensationSetting = async(selectedCompensationId) => {
        if (selectedCompensationId > 0) {
            try {
                let result = await this.props.compensationSetting(
                    selectedCompensationId, {}, "GET");
                if (result) {
                    if (result.is_individual_goal) {
                        this.getIndividualRevenueActual(selectedCompensationId);
                    } else {
                        this.getAgencyRevenueActual(result.pl_profile);
                    }
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
    }

    getIndividualRevenueActual = async (selectedCompensationId) => {
        if (selectedCompensationId > 0) {
            try {
                let result = await this.props.revenueActual(
                    selectedCompensationId, this.state.revenueActualList, "GET");
                if (result) {
                    let revenueActualList = result.map(revenue => ({...revenue}));
                    this.setState({revenueActualList});
                }            
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    }

    getAgencyRevenueActual = async (agencyProfile) => {
        if (agencyProfile > 0) {
            try {
                let result = await AgencyRevenueService.getRevenue(agencyProfile);
                if (200 === result.status) {
                    let revenueActualList = result.data.revenues.map(revenue => ({...revenue}));
                    this.setState({revenueActualList});
                }            
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
            }
        } else {
            toast.error(
                "The selected compensation has agency goal setup but no agency "
                +"profile has been selected to get goals. Please goto compensation "
                +"profile and select an agency profile to get agency goals.", {autoClose: 8000})
        }
    }

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date) => {
        this.setState({reviewDate: date});
    };

    printReport = async (e) => {
        const {selectedCompensationId, reviewDate} = this.state;

        if (selectedCompensationId > 0) {
            let reviewDateStr = moment(reviewDate).format("MM-DD-YYYY");
            this.setState({isLoading: true});
            try {
                let result = await this.props.ReportAction({
                    type: GET_COMMISSION_REPORT, 
                    compProfileList: [selectedCompensationId],
                    reviewDate: reviewDateStr
                });
                
                if (result) {
                    let content = result.content;
                    let fileName = result.file_name;
                    downloadPDF(content, fileName);
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
            this.setState({isLoading: false});
        } else {
            toast.error("Please select compensation profile.");
        }
    }

    render() {
        const {
            selectedCompensationId, compensationProfileList, 
            reviewDate, revenueActualList, isLoading
        } = this.state;

        const {compensationSetting} = this.props.report;

        let topRenewalRevenueRow = [], bottomRenewalRevenueRow = [],
            topNewRevenueRow = [], bottomNewRevenueRow = [],
            topTableHeader = [], bottomTableHeader = [],
            topCombinedRevenueRow = [], bottomCombinedRevenueRow = [];
        
        if (revenueActualList.length > 0) {
            topTableHeader.push(<th key={-1}>Month</th>);
            topNewRevenueRow.push(<td key={-1}>New</td>);
            topRenewalRevenueRow.push(<td key={-1}>Renewal</td>);
            topCombinedRevenueRow.push(<td key={-1}>Revenue</td>);
            bottomTableHeader.push(<th key={-1}>Month</th>);
            bottomNewRevenueRow.push(<td key={-1}>New</td>);
            bottomRenewalRevenueRow.push(<td key={-1}>Renewal</td>);
            bottomCombinedRevenueRow.push(<td key={-1}>Revenue</td>);
            revenueActualList.map((revenue, index) => {
                if (6 > index) {
                    topTableHeader.push(
                        <th className="text-center" key={"month-" + revenue.id}>
                            <span className="revenue-block">{revenue.month_name}</span>
                        </th>
                    );

                    topNewRevenueRow.push(
                        <td key={"newrevenue-" + revenue.id}>
                            <NumberFormat type="tel" value={revenue.new_revenue}  
                                thousandSeparator={true} prefix={'$ '} 
                                className="form-control form-control-sm text-center" 
                                disabled={true} allowNegative={false} 
                            />
                        </td>
                    );
                    topRenewalRevenueRow.push(
                        <td key={"revenue-" + revenue.id}>
                            <NumberFormat type="tel" value={revenue.renewal_revenue} 
                                thousandSeparator={true} prefix={'$ '} 
                                className="form-control form-control-sm text-center" 
                                disabled={true} allowNegative={false} 
                            />
                        </td>
                    );
                    topCombinedRevenueRow.push(
                        <td key={"combined-" + revenue.id}>
                            <NumberFormat type="tel" value={revenue.combined_revenue} 
                                thousandSeparator={true} prefix={'$ '}
                                className="form-control form-control-sm text-center" 
                                disabled={true} allowNegative={false} 
                            />
                        </td>
                    );
                } else {
                    bottomTableHeader.push(
                        <th className="text-center" key={"month-" + revenue.id}>
                            <span className="revenue-block">{revenue.month_name}</span>
                        </th>
                    );
                    bottomNewRevenueRow.push(
                        <td key={"newrevenue-" + revenue.id}>
                            <NumberFormat type="tel" value={revenue.new_revenue}  
                                thousandSeparator={true} prefix={'$ '} 
                                className="form-control form-control-sm text-center" 
                                disabled={true} allowNegative={false} 
                            />
                        </td>
                    );
                    bottomRenewalRevenueRow.push(
                        <td key={"revenue-" + revenue.id}>
                            <NumberFormat type="tel" value={revenue.renewal_revenue} 
                                thousandSeparator={true} prefix={'$ '} 
                                className="form-control form-control-sm text-center" 
                                disabled={true} allowNegative={false} 
                            />
                        </td>
                    );
                    bottomCombinedRevenueRow.push(
                        <td key={"combined-" + revenue.id}>
                            <NumberFormat type="tel" value={revenue.combined_revenue}  
                                thousandSeparator={true} prefix={'$ '} 
                                className="form-control form-control-sm text-center" 
                                disabled={true} allowNegative={false} 
                            />
                        </td>
                    );
                }

                return true;
            });
        }

        const {modal, toggleModal} = this.props;

        return (
            <Modal isOpen={modal} size="lg" toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {} Report
                </ModalHeader>
                <ModalBody className="bg-white">
                    <div className="w-block">
                        <div className="row">
                            <div className="col-sm-3 text-sm-right">
                                <label className="mb-0 pt-1">
                                    Compensation Profile:
                                </label>
                            </div>
                            <div className="col-sm-3">
                                <select name="user_name" className="form-control"
                                    onChange={this.compensationChangeHandler}
                                    value={selectedCompensationId}
                                >
                                    <option key="0" value={0}>
                                        Select Compensation Profile
                                    </option>
                                    {compensationProfileList.map((profile, index) => 
                                        <option key={index} value={profile.id}>
                                            {profile.date_range}
                                        </option>
                                    )}
                                </select>
                            </div>
                            <div className="col-sm-3 text-sm-right">
                                <label className="mb-0 pt-1">Review Date: </label>
                            </div>
                            <div className="col-sm-3">
                                <div className="div-datepicker">
                                    <DatePicker
                                        selected={reviewDate}
                                        onChangeRaw={this.handleDateChangeRaw}
                                        onChange={(event) => this.handleDateChange(event)}
                                        dateFormat="MM-DD-YYYY"
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={moment('2012-01-01')}
                                        maxDate={moment().add(5, 'years')}
                                        autoComplete="off"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {selectedCompensationId > 0 ?
                        <div className="w-block mt-3">                                
                            <div className="table-responsive revenue-table">
                                <table>
                                    <thead>
                                    <tr>{topTableHeader}</tr>
                                    </thead>
                                    <tbody>
                                        {compensationSetting.is_individual_goal ?
                                            compensationSetting.combine_new_renewal ?
                                                <tr>{topCombinedRevenueRow}</tr> 
                                                :
                                                <React.Fragment>
                                                    <tr>{topNewRevenueRow}</tr>
                                                    <tr>{topRenewalRevenueRow}</tr>
                                                </React.Fragment>
                                            :
                                            compensationSetting.is_agency_goal_combined ?
                                                <tr>{topCombinedRevenueRow}</tr> 
                                                :
                                                <React.Fragment>
                                                    <tr>{topNewRevenueRow}</tr>
                                                    <tr>{topRenewalRevenueRow}</tr>
                                                </React.Fragment>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-responsive revenue-table r-table-2 hidden">
                                {revenueActualList.length > 6 ?
                                    <table>
                                        <thead>
                                            <tr>{bottomTableHeader}</tr>
                                        </thead>
                                        <tbody>
                                        {compensationSetting.is_individual_goal ?
                                            compensationSetting.combine_new_renewal ?
                                                <tr>{bottomCombinedRevenueRow}</tr> 
                                                :
                                                <React.Fragment>
                                                    <tr>{bottomNewRevenueRow}</tr>
                                                    <tr>{bottomRenewalRevenueRow}</tr>
                                                </React.Fragment>
                                            :
                                            compensationSetting.is_agency_goal_combined ?
                                                <tr>{bottomCombinedRevenueRow}</tr> 
                                                :
                                                <React.Fragment>
                                                    <tr>{bottomNewRevenueRow}</tr>
                                                    <tr>{bottomRenewalRevenueRow}</tr>
                                                </React.Fragment>
                                        }
                                        </tbody>
                                    </table>
                                    :
                                    ""
                                }
                            </div>
                        </div>
                        : null 
                    }
                </ModalBody>
                <ModalFooter>
                    {isLoading && 
                        <img src={loadingGIF} alt="loading..." height="32" width="32" /> 
                    }
                    <Button className='btn btn-success' 
                        onClick={this.printReport}
                        disabled={isLoading}
                    >
                        Print
                    </Button>
                    <Button className='btn btn-secondary' onClick={toggleModal}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/staffDashboardNav/CommissionReport.js